export const itemFilterTypes = {
  industryCpdCategory: 'industryCpdCategoryFilter',
  cpdCategory: 'cpdCategoryFilter',
  publisher: 'publisherFilter',
  association: 'associationFilter',
  contentLength: 'contentLengthFilter',
  eventDuration: 'eventDurationFilter',
  contentType: 'contentType',
  status: 'status',
  taskStatus: 'taskStatus',
  location: 'location',
  goal: 'goal',
  publisherGoal: 'publisherGoal',
  bookmark: 'bookmark',
}


// WEBPACK FOOTER //
// ./src/constants/item-filter.js